import React, { useCallback } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../hooks/useModal';
import { image } from '../../../utils/data/baseUrl';
import useStateControls from '../../../hooks/useStateControls';
import { dateFromNow } from '../../../utils/helpers/helpers';
import { useTranslation } from '../../../translations';
import { useLanguageControls } from '../../../hooks/useLanguageControls';

const AboutModal = React.forwardRef(function AboutModal(
  { type, img, title, description, buttons, className, noImgBg, date, callback: onClose },
  ref,
) {
  const stateControls = useStateControls();
  const { closeModal, id } = useModal();
  const { t } = useTranslation();
  const { isArabic } = useLanguageControls();

  const currentTitle = date ? t(title)?.replace('{date}', dateFromNow(date, isArabic)) : t(title);

  const close = () => closeModal({ id });

  return (
    <CustomModal>
      <div
        className={`about-modal ${type ? 'about-modal_' + type : ''} ${className ? className : ''} ${
          noImgBg ? 'about-modal_noImgBg' : ''
        }`}
        ref={ref}
      >
        <div className='about-modal__bg' onClick={close} />
        <div className='about-modal__content'>
          {img && (
            <div className='about-modal__image'>
              <img src={img.includes('http') ? img : img.includes('/images') ? img : image(img)} alt={t(title)} />
            </div>
          )}
          {title && <h2 className='about-modal__title'>{safeHTML(currentTitle)}</h2>}
          {description && <p className='about-modal__text'>{safeHTML(t(description))}</p>}
          <div className={'about-modal__buttons'}>
            {buttons.map((button, index) => {
              const { callback, callbackOptions, className, text } = button;
              return (
                <CustomButton
                  key={`AboutModalBtn-${index}`}
                  className={className}
                  text={text}
                  redirect={button.redirect}
                  onClick={() => {
                    if (callback) stateControls[callback](callbackOptions);
                    onClose?.();
                    closeModal(button.closeAll ? { type: 'all' } : { id });
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </CustomModal>
  );
});
export default AboutModal;
AboutModal.propTypes = {};
